import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Language, storeLanguage, supportedLanguages } from '../../i18n/i18n';

@Component({
  selector: 'app-anonymous-page-layout',
  templateUrl: './anonymous-page-layout.component.html',
  styleUrls: ['./anonymous-page-layout.component.scss'],
})
export class AnonymousPageLayoutComponent {
  constructor(private translateService: TranslateService) {}

  get languages() {
    return supportedLanguages;
  }

  isActiveLanguage(language: Language) {
    return this.translateService.currentLang === language;
  }

  switchLanguage(language: Language, event: MouseEvent) {
    event.preventDefault();
    if (language === this.translateService.currentLang) {
      return;
    }
    this.translateService.use(language);
    storeLanguage(language);
  }
}
